import React from 'react';
import styled from 'styled-components';
import { Heading } from '@alefeducation/ui-elements-library-core';
import emptyOrgImage from '../../assets/images/emptyOrgImage.svg';

export const StyledOrgContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;

  > :nth-child(2) {
    margin-bottom: 7px;
  }
`;

const Image = styled.img`
  margin-bottom: 30px;
`;

interface Props {
  title: string;
  description?: string;
  image?: any;
  size?: {
    height: string;
    width: string;
  };
}

const NoOrganisationsView = ({
  title,
  description,
  image = emptyOrgImage,
  size = {
    height: '129px',
    width: '163px',
  },
}: Props) => {
  return (
    <StyledOrgContainer className="empty-message-view">
      <Image src={image} alt="img-no-skill" {...size} />

      <Heading variant="heading-medium" data-testid="title">
        {title}
      </Heading>

      {description && (
        <Heading
          variant="heading-small"
          color="primary.100"
          data-testid="description"
        >
          {description}
        </Heading>
      )}
    </StyledOrgContainer>
  );
};

export default NoOrganisationsView;
